import React, { useState, useEffect } from "react";
import { Modal, Select, Spin } from "antd";
import CoinsGIF from "../assets/images/illustrations/coins.gif";
import { showSuccessNotification } from "../common/utils/notification";
import { _restaurants_in_lga, _get_all_state, _get_cities_by_state_code } from "../common/axios_services";

const ReferralModals = ({
  howReferralWorkModal,
  setHowReferralWorkModal,
  referralMessageModal,
  setReferralMessageModal,
  locationModalOpen,
  setLocationModalOpen,
  vendorModalOpen,
  setVendorModalOpen,
  userData,
}) => {
  const referralMessage = `Hello You, Konnect lets you Eat More & Spend Less - 20% instant discount + Free Delivery. Click https://konnect.ws/?konnectrfc=${userData?.accountId}`;

  const [selectedState, setSelectedState] = useState("");
  const [selectedLga, setSelectedLga] = useState("");

  const [dbStates, setDbStates] = useState([]);
  const [dbLgas, setDbLgas] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingLgas, setLoadingLgas] = useState(false);

  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [loadingVendors, setLoadingVendors] = useState(false);

  useEffect(() => {
    if (locationModalOpen && dbStates.length === 0) {
      setLoadingStates(true);
      _get_all_state()
        .then((res) => {
          setDbStates(res?.data?.data || res?.data || []);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoadingStates(false));
    }
  }, [locationModalOpen]);

  useEffect(() => {
    if (selectedState) {
      setLoadingLgas(true);
      _get_cities_by_state_code(selectedState)
        .then((res) => {
          setDbLgas(res?.data?.data || res?.data || []);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoadingLgas(false));
      setSelectedLga("");
    } else {
      setDbLgas([]);
    }
  }, [selectedState]);

  useEffect(() => {
    if (vendorModalOpen) {
      setLoadingVendors(true);
      _restaurants_in_lga({ page: 1, per_page: 100 })
        .then((res) => {
          setVendors(res?.data?.data?.data || res?.data?.data || []);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoadingVendors(false));
    }
  }, [vendorModalOpen]);

  const copyRefMessage = () => {
    const tempTextarea = document.createElement("textarea");
    tempTextarea.value = referralMessage;
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    tempTextarea.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    setReferralMessageModal(false);
    showSuccessNotification("Referral link copied successfully");
  };

  const copyLink = (link) => {
    const tempTextarea = document.createElement("textarea");
    tempTextarea.value = link;
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    tempTextarea.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    showSuccessNotification("Referral link copied successfully");
  };

  const locationLink = selectedState && selectedLga
    ? `https://konnect.ws/marketplace?state=${encodeURIComponent(selectedState)}&lga=${encodeURIComponent(selectedLga)}&konnectrfc=${userData?.accountId}`
    : "";

  const vendorLink = selectedVendor
    ? `https://konnect.ws/restaurant/${selectedVendor}?konnectrfc=${userData?.accountId}`
    : "";

  return (
    <>
      <Modal
        open={howReferralWorkModal}
        footer={null}
        centered
        className="referal-modal"
        onCancel={() => setHowReferralWorkModal(false)}
      >
        <div className="center-text ref-modal">
          <div>
            <h3>How Referral Works</h3>
            <img src={CoinsGIF} className="w-[50px] mx-auto my-10" alt="gift" />
            <p className="text-left">
              Click the <span className="font-gilroyBold">Copy Referral Message</span> button & share
              with friends & restaurants.
            </p>
            <h4 className="uppercase text-left mt-4 mb-2">What You Get</h4>
            <ul className="list-disc pl-5 text-left my-2">
              <li>
                Upgrade to Tier 2 and get double cashback to pay off your next
                order
              </li>
              <li>
                Up to NGN 10,000 weekly as sales income from business referrals
              </li>
              <li>
                Tier 2 gets up to NGN 2,500 weekly as extra cashback as they
                spend
              </li>
            </ul>
            <p className="text-left">
              <strong>
                <em>
                  What are you waiting for.... Upgrade to Tier 2, Refer & Get
                  Paid weekly
                </em>
              </strong>
            </p>
          </div>
        </div>
      </Modal>

      <Modal
        open={referralMessageModal}
        footer={null}
        centered
        className="referal-modal"
        onCancel={() => setReferralMessageModal(false)}
        width={550}
      >
        <div className="text-left ref-modal p-2">
          <h3 className="header_summary mb-2 font-bold text-2xl text-gray-900">Your Referral Links</h3>
          <p className="text-gray-500 text-sm mb-4">
            Copy and share your links to refer users, vendors, and ambassadors:
          </p>

          <div className="space-y-3">
            {[
              { label: "Marketplace Link", link: `https://konnect.ws/marketplace?ref=${userData?.accountId || ""}` },
              { label: "Business Partner Link", link: `https://konnect.ws/business?type=business&ref=${userData?.accountId || ""}` },
              { label: "Ambassador Link", link: `https://konnect.ws/ambassadors?type=ambassador&ref=${userData?.accountId || ""}` },
              { label: "Wise9ja Campaign Link", link: `https://konnect.ws/wise9ja?type=wise9ja&ref=${userData?.accountId || ""}` },
            ].map((item, idx) => (
              <div key={idx} className="bg-gray-50 border border-gray-200 rounded-xl p-3">
                <p className="font-bold text-gray-900 mb-1">{item.label}</p>
                <div className="flex gap-2">
                  <input
                    type="text"
                    readOnly
                    value={item.link}
                    className="bg-white border border-gray-300 text-xs font-mono rounded-lg p-2 flex-1 outline-none text-gray-700"
                  />
                  <button
                    onClick={() => copyLink(item.link)}
                    className="bg-black hover:bg-gray-800 text-white font-bold text-xs px-4 py-2 rounded-lg transition-all cursor-pointer"
                  >
                    Copy
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>

      <Modal
        open={locationModalOpen}
        footer={null}
        centered
        className="referal-modal"
        onCancel={() => {
          setLocationModalOpen(false);
          setSelectedState("");
          setSelectedLga("");
        }}
      >
        <div className="center-text ref-modal space-y-5">
          <h3 className="header_summary mb-4 font-gilroyBold text-2xl">Refer by Location</h3>
          <div className="space-y-4 text-left">
            <div>
              <label className="block text-sm font-gilroyBold text-gray-700 mb-1">State</label>
              <Select
                placeholder="Select State"
                value={selectedState || undefined}
                onChange={setSelectedState}
                style={{ width: "100%" }}
                size="large"
                loading={loadingStates}
                options={dbStates.map((s) => ({ value: s.name, label: s.name }))}
              />
            </div>
            <div>
              <label className="block text-sm font-gilroyBold text-gray-700 mb-1">LGA (City)</label>
              <Select
                placeholder="Select LGA"
                value={selectedLga || undefined}
                onChange={setSelectedLga}
                disabled={!selectedState}
                style={{ width: "100%" }}
                size="large"
                loading={loadingLgas}
                options={dbLgas.map((l) => ({ value: l.name, label: l.name }))}
              />
            </div>
          </div>

          {locationLink && (
            <div className="mt-4 space-y-2">
              <textarea
                rows="3"
                readOnly
                value={locationLink}
                className="w-full p-3 border border-gray-200 rounded-lg text-sm bg-gray-50 text-gray-600"
              />
              <button
                onClick={() => {
                  copyLink(locationLink);
                  setLocationModalOpen(false);
                }}
                className="w-full text-base font-gilroyBold bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition"
              >
                Copy Location Link
              </button>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        open={vendorModalOpen}
        footer={null}
        centered
        className="referal-modal"
        onCancel={() => {
          setVendorModalOpen(false);
          setSelectedVendor("");
        }}
      >
        <div className="center-text ref-modal space-y-5">
          <h3 className="header_summary mb-4 font-gilroyBold text-2xl">Refer by Vendor</h3>
          <div className="space-y-4 text-left">
            <div>
              <label className="block text-sm font-gilroyBold text-gray-700 mb-1">Select Restaurant / Vendor</label>
              <Select
                showSearch
                placeholder="Search or Select Vendor"
                value={selectedVendor || undefined}
                onChange={setSelectedVendor}
                style={{ width: "100%" }}
                size="large"
                loading={loadingVendors}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
                options={vendors.map((v) => ({ value: v.businessId, label: v.name }))}
              />
            </div>
          </div>

          {vendorLink && (
            <div className="mt-4 space-y-2">
              <textarea
                rows="3"
                readOnly
                value={vendorLink}
                className="w-full p-3 border border-gray-200 rounded-lg text-sm bg-gray-50 text-gray-600"
              />
              <button
                onClick={() => {
                  copyLink(vendorLink);
                  setVendorModalOpen(false);
                }}
                className="w-full text-base font-gilroyBold bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition"
              >
                Copy Vendor Link
              </button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ReferralModals;
